<template>
  <v-app id="app" oncontextmenu="return false;">
    
    <!-- <v-app-bar class="white" app flat>
      <v-icon x-large>mdi-camera</v-icon>
      <v-toolbar-title class="pl-2 display-1">TOMWEDGE</v-toolbar-title>
      <v-toolbar-title class="grey--text display-1">IMAGES</v-toolbar-title>
      <v-spacer />
      <v-btn
        v-for="footerlink in footerlinks"
        :key="footerlink.link"
        :href="footerlink.link"
        :color="footerlink.colour"
        class="mx-4"
        icon
        target="_blank"
      >
        <v-icon x-large>{{ footerlink.icon }}</v-icon>
      </v-btn>

      <template v-slot:extension>
        <v-tabs centered>
          <v-tab
            v-for="link in links"
            :key="link.text"
            :to="{
              name: link.route,
              params: { pagename: link.title, filter: link.filter },
            }"
          >{{ link.title }}</v-tab>
        </v-tabs>
      </template>
    </v-app-bar> -->
    <Navigation class="d-none d-md-block" :links="links" :footerlinks="footerlinks" />
    <NavigationMobile class="d-md-none" :links="links" :footerlinks="footerlinks" />

    <v-content>
      <v-container >
        <router-view :key="$route.fullPath"></router-view>
        <!-- <HomeTest /> -->
      </v-container>
    </v-content>
    <!-- </v-content> -->

    <v-footer app class="white">
      <small>&copy; Tom Wedge Images - {{ new Date().getFullYear() }}</small>
      <v-spacer></v-spacer>
      <small>Powered by Vue/Vuetify/Firebase</small>
    </v-footer>
  </v-app>
</template>

<script>
import firebaseApp from "@/fb";
// import HomeTest from "./views/HomeTest";
import Navigation from "@/components/Navigation"
import NavigationMobile from "@/components/NavigationMobile"

export default {
 components: { Navigation, NavigationMobile },
  props: {
    source: String,
  },
  data: () => ({
    drawer: null,
    links: [],
    linksother: [
      { icon: "mdi-email", text: "Contact", route: "/contact" },
      { icon: "mdi-information", text: "About", route: "/About" },
    ],
    footerlinks: [],
  }),
  created() {
    const db = firebaseApp.firestore();

    db.collection("navigation")
      .orderBy("position")
      .get()
      .then((snapshot) => {
        snapshot.forEach((doc) => {
          this.links.push(doc.data());
        });
      });

    db.collection("footer")
      .orderBy("position")
      .get()
      .then((snapshot) => {
        snapshot.forEach((doc) => {
          this.footerlinks.push(doc.data());
        });
      });

    this.$vuetify.theme.light = true;
  },
};
</script>

<style>
</style>
